// Fire a first-party analytics event to /api/collect (via the analytics.client
// plugin). Safe to call anywhere client-side; no-ops on the server and when the
// plugin hasn't provided a tracker (e.g. DNT/GPC set).
//
//   const track = useTrack()
//   track('form_submit', { form: 'contact' })
export const useTrack = () => {
  if (process.server) return () => {}
  const { $track } = useNuxtApp()
  return typeof $track === 'function' ? $track : () => {}
}
